export const LOGOUT = 'LOGOUT';
